export const LOGOUT = 'LOGOUT';
